const Resume=()=>{
    const design=(
        <>
               <div className="container-fluid p-4  resume-section" id="resume">
                    <div className="row">
                        <h2>Resume</h2>
                        <h6>10th Standard from <b>Shibli Nursery High School 2016-17</b> Azamgarh, Uttar Pradesh, <b>Diploma in Computer Science.</b> Completed from <b>Integral University</b>. Lucknow, Uttar Pradesh 2017-20 After Same Collage to Completed <b>B Tech In CSE.</b> 2020-23</h6>
                        <br />
                        <div className="row">
                            <div className="col-md-6 ">
                                <br />
                                <h3>Summary</h3>
                                 <div className="row p-4">
                                 <div className="col-md-12 resume-box">
                                <h4>Akhzar Azmi</h4>
                                <p>My name is <b>Mohd Akhzar</b>  I'm from Azamgarh, Uttar Pradesh 276001. Born on <b>1st March 2001</b> Village <b>Chhaun</b> Azamgarh 276302. <br /> My Father name is <b>Mr. Imran Ahmad</b> he is a Business Man. And my mother name is <b>Mrs. Habiba Akhtar</b> she is a house wife, we are four brothers and three sister.</p>
                                <ul>
                                    <li className='my-3'>Born on <b>1st March 2001</b> Village <b>Chhaun, Azamgarh</b></li>
                                    <li className='my-3'>My First School is <b>Madar-Satul-Balag</b> Which is in Village Chhaun Azamgarh, I Have Studied Only One Class in that 2005, My Teacher Name is <b>Mohd Ashad.</b></li>
                                    <li className='my-3'>After that I Came to City Azamgarh in 2005 and did Further Studies in <b>Reshad Nursery School</b> Where I Studied From <b>L.K.G to 4th Standard </b>from the Year <b>2005 to 2010</b></li>
                                    <li className='my-3'>After 4th Class, took Addmission in New School <b>Shibli Nursery High School</b> from Where I Studied from <b>5th Class to 10th Class</b> from the <b>Year 2010 to 2017</b></li>
                                </ul>
                                </div>
                                 </div>
                                 <h3>Education</h3>
                                 <br />
                                 <div className="row px-4">
                                    <div className="col-md-12 resume-box">
                                        <h4>Bachelor of Computer Science</h4>
                                        <p style={{backgroundColor:"#ccc", width:"40%"}} className='d-flex justify-content-center'>2020 - 23</p>
                                        <p>Integral University Lucknow.</p>
                                        <p>B-Tech in Computer Science & Engineering at Integral University from Lucknow</p>
                                    </div>
                                 </div>
                                 <div className="row px-4">
                                    <div className="col-md-12 resume-box">
                                        <h4>Diploma in Computer Science</h4>
                                        <p style={{backgroundColor:"#ccc", width:"40%"}} className='d-flex justify-content-center'>2017 - 20</p>
                                        <p>Integral University Lucknow.</p>
                                        <p>Completed from Integral University. Lucknow, Uttar Pradesh 2017-2020</p>
                                    </div>
                                 </div>
                                 <div className="row px-4">
                                    <div className="col-md-12 resume-box">
                                        <h4>High School</h4>
                                        <p style={{backgroundColor:"#ccc", width:"40%"}} className='d-flex justify-content-center'>2016 - 17</p>
                                        <p>Shibli National High School.</p>
                                        <p>Completed from Shibli Nursery High School. Azamgarh, Uttar Pradesh 2016 - 2017</p>
                                    </div>
                                 </div>
                            </div>
                            <div className="col-md-6 ">
                                <br />
                                <h3>Professional Experience</h3>
                                 <div className="row p-4">
                                 <div className="col-md-12 resume-box">
                                <h4>React JS</h4>
                                <p style={{backgroundColor:"#ccc", width:"60%"}} className='d-flex justify-content-center'>2022 - Present</p>
                                <ul>
                                    <li className='my-3'>Developing new user-facing features using React.js, Building reusable components and front-end libraries for future use</li>
                                    <li className='my-3'>Translating designs and wireframes into high quality code</li>
                                    <li className='my-3'>Thorough understanding of React.js and its core principles</li>
                                    <li>Familiarity with newer specifications of EcmaScript, Knowledge of modern authorization mechanisms, such as JSON Web Token</li>
                                </ul>
                                </div>
                                 </div>
                                 <div className="row px-4">
                                    <div className="col-md-12 resume-box">
                                        <h4>Node JS</h4>
                                        <p style={{backgroundColor:"#ccc", width:"60%"}} className='d-flex justify-content-center'>2023 - Present</p>
                                    <ul>
                                    <li className='my-3'>Develop and manage server components, Implement storage solutions.</li>
                                    <li className='my-3'>Database and external queries are running at optimal performance.</li>
                                    <li className='my-3'>Integrate server-side logic into user-facing components created frontend.</li>
                                    <li>Run tests, fix problems, and provide technical support.</li>
                                    </ul>
                                    </div>
                                 </div>
                                 <div className="row px-4">
                                    <div className="col-md-12 resume-box">
                                        <h4>Frontend Developer</h4>
                                        <p style={{backgroundColor:"#ccc", width:"60%"}} className='d-flex justify-content-center'>2020 - Present</p>
                                    <ul>
                                    <li className='my-3'>Proficiency in HTML CSS Bootstrap JavaScript and jQuery and Understanding of server-side CSS.</li>
                                    <li className='my-3'>Responsive and adaptive design, Determining the structure and design of web pages.</li>
                                    <li className='my-3'>Developing and implementing highly responsive user interface components using react concepts, Improving front-end performance.</li>
                                    <li className="my-3">User interface design, Identifying web-based user interactions.</li>
                                    </ul>
                                    </div>
                                 </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
        </>
    )
    return design;
}
export default Resume;